module.exports = __webpack_public_path__ + "static/media/f.75da3b7d.gif";